import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap';

export const ContactModal = ({
  isOpen,
  type,
  toggle,
  teamMembers,
  patient,
  handleContact,
}) => {
  const [useContact, setUseContact] = useState<boolean | null>(null);
  const [selectedContact, setSelectedContact] = useState<string | null>(null);
  console.log('selectedContact: ', selectedContact);

  const [saving, setSaving] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (isOpen) {
      setUseContact(null);
      setSelectedContact(null);
    }
  }, [isOpen]);

  const handleSave = async () => {
    setSaving(true);
    console.log('selectedContact: ', selectedContact);
    console.log('type', type);
    handleContact(selectedContact, type);
  };

  const title = type == 'primary' ? 'Primary Contact' : 'Emergency Contact';
  const message =
    type == 'primary'
      ? 'We will reach out to the Primary Contact first when we have questions or updates related to this campaign. You can set yourself as the Primary Contact.'
      : 'The Emergency Contact is authorized to make decisions about this campaign on your behalf if you are not able to respond.';

  return (
    <Modal centered isOpen={isOpen} toggle={toggle} size='lg'>
      <ModalBody>
        <h4>Add {title}</h4>
        <p>{message}</p>
        <Label>Do you want to use an existing contact for this role?*</Label>
        <FormGroup check inline className='mb-3'>
          <Label check>
            <Input
              type='radio'
              checked={useContact == true}
              onChange={() => {
                setUseContact(true);
              }}
              name='useContact'
            />
            Yes
          </Label>
        </FormGroup>
        <FormGroup check inline className='mb-3'>
          <Label check>
            <Input
              type='radio'
              checked={useContact == false}
              onChange={() => {
                setUseContact(false);
              }}
              name='useContact'
            />
            No
          </Label>
        </FormGroup>
        {useContact == true && (
          <FormGroup>
            <Label>Select Contact</Label>
            <Input
              type='select'
              onChange={(e) => setSelectedContact(e.target.value)}
            >
              <option value=''>Select Contact</option>
              {type == 'primary' && (
                <option value='patient'>
                  Client ({patient?.person?.email})
                </option>
              )}
              {teamMembers.map((member) => (
                <option key={member.id} value={member.id}>
                  {`${member.person.first_name} ${member.person.last_name}`}
                </option>
              ))}
            </Input>
          </FormGroup>
        )}
        <div>
          <Button color='outline-dark' onClick={toggle} disabled={saving}>
            Cancel
          </Button>
          {selectedContact && (
            <Button color='primary' onClick={handleSave} disabled={saving}>
              {saving ? `Saving` : `Save Contact`}
            </Button>
          )}
          {useContact == false && type === 'primary' && (
            <Button
              color='primary'
              onClick={() => {
                history.push('/team/add', { primary: true });
              }}
            >
              Add New Contact
            </Button>
          )}
          {useContact == false && type === 'emergency' && (
            <Button
              color='primary'
              onClick={() => {
                history.push('/team/add', { emergency: true });
              }}
            >
              Add New Contact
            </Button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};
